import { ControlButton } from "@xyflow/react"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import OpenInNewOffIcon from "@mui/icons-material/OpenInNewOff"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { useKeymap } from "@features/keymap/useKeymap"
import { SetState } from "@custom-types/utils"
import { shortcuts } from "@features/keymap/shortcuts"

export const SelectInsideGroupToggleButton = (props: {
  isOn: boolean
  onCanSelectChange: SetState<boolean>
}) => {
  const keymap = useKeymap()

  const handleToggle = () => props.onCanSelectChange((state) => !state)

  return (
    <>
      <KeyBinding
        bind={shortcuts["toggle-select-inside-group"]}
        onKeyDown={() => props.onCanSelectChange(true)}
        onKeyUp={() => props.onCanSelectChange(false)}
      />
      <ControlButton
        data-testid="graph-controls-toggle-select-in-group-btn"
        onClick={handleToggle}
        title={keymap.getKeymaps().byId.get("toggle-select-inside-group")?.desc}
      >
        {props.isOn ? <OpenInNewIcon /> : <OpenInNewOffIcon />}
      </ControlButton>
    </>
  )
}
